import React from "react";

const Hometvshows = () => {
  return (
    <div className="movies-homepage">
      <h3>TV SHOWS</h3>
      <div>
        <h1 className="home-comingsoon">Feature coming soon</h1>
      </div>
    </div>
  );
};

export default Hometvshows;
